import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import BusinessDashboard from "@/pages/BusinessDashboard";
import ReviewForm from "@/pages/ReviewForm";
import Login from "@/pages/Login";

function App() {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const businessId = localStorage.getItem('business_id');
    const businessName = localStorage.getItem('business_name');
    
    if (token && role) {
      setAuth({ token, role, businessId, businessName });
    }
  }, []);

  const handleLogin = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('role', data.role);
    if (data.business_id) {
      localStorage.setItem('business_id', data.business_id);
      localStorage.setItem('business_name', data.business_name);
    }
    setAuth(data);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('business_id');
    localStorage.removeItem('business_name');
    setAuth(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/review/:businessId" element={<ReviewForm />} />
          <Route path="/login" element={
            auth ? <Navigate to={auth.role === 'super_admin' ? '/admin' : '/business'} /> : <Login onLogin={handleLogin} />
          } />
          <Route path="/admin" element={
            auth && auth.role === 'super_admin' ? <SuperAdminDashboard onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/business" element={
            auth && auth.role === 'business' ? <BusinessDashboard auth={auth} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;